// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SplatRouteImport } from './routes/$'
import { Route as AProposRouteImport } from './routes/a-propos'
import { Route as AvisClientsRouteImport } from './routes/avis-clients'
import { Route as CalculateurRouteImport } from './routes/calculateur'
import { Route as CielEtoileMariageRouteImport } from './routes/ciel-etoile-mariage'
import { Route as ConditionsDeLocationRouteImport } from './routes/conditions-de-location'
import { Route as ContactezNousRouteImport } from './routes/contactez-nous'
import { Route as DjAvignonRouteImport } from './routes/dj-avignon'
import { Route as DjSaintSylvestreRouteImport } from './routes/dj-saint-sylvestre'
import { Route as DjVaucluseRouteImport } from './routes/dj-vaucluse'
import { Route as GalerieRouteImport } from './routes/galerie'
import { Route as GuideMariageVaucluseRouteImport } from './routes/guide-mariage-vaucluse'
import { Route as LeConceptRouteImport } from './routes/le-concept'
import { Route as LocationGenderRevealRouteImport } from './routes/location-gender-reveal'
import { Route as LocationKaraokeVaucluseRouteImport } from './routes/location-karaoke-vaucluse'
import { Route as LocationPhotoboothAvignonRouteImport } from './routes/location-photobooth-avignon'
import { Route as LocationSonoMariageRouteImport } from './routes/location-sono-mariage'
import { Route as MentionsLegalesRouteImport } from './routes/mentions-legales'
import { Route as MerciRouteImport } from './routes/merci'
import { Route as PlanDuSiteRouteImport } from './routes/plan-du-site'
import { Route as PolitiqueConfidentialiteRouteImport } from './routes/politique-confidentialite'
import { Route as RealisationsRouteImport } from './routes/realisations'
import { Route as SoireeKaraokeAvignonRouteImport } from './routes/soiree-karaoke-avignon'
import { Route as SoireesThematiquesRouteImport } from './routes/soirees-thematiques'
import { Route as SonoLumiereRouteImport } from './routes/sono-lumiere'
import { Route as TarifsRouteImport } from './routes/tarifs'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as ActualitesIndexRouteImport } from './routes/actualites.index'
import { Route as ActualitesSlugRouteImport } from './routes/actualites.$slug'
import { Route as DjAnniversaireVilleRouteImport } from './routes/dj-anniversaire.$ville'
import { Route as DjEntrepriseVilleRouteImport } from './routes/dj-entreprise.$ville'
import { Route as DjMariageIndexRouteImport } from './routes/dj-mariage.index'
import { Route as DjMariageVilleRouteImport } from './routes/dj-mariage.$ville'
import { Route as DjMariagePackSonoLumiereRouteImport } from './routes/dj-mariage.pack-sono-lumiere'
import { Route as EnWeddingDjProvenceRouteImport } from './routes/en.wedding-dj-provence'
import { Route as LieuxIndexRouteImport } from './routes/lieux.index'
import { Route as LieuxSlugRouteImport } from './routes/lieux.$slug'
import { Route as LocationMaterielIndexRouteImport } from './routes/location-materiel.index'
import { Route as LocationMaterielSlugRouteImport } from './routes/location-materiel.$slug'
import { Route as SoireesEvenementsIndexRouteImport } from './routes/soirees-evenements.index'
import { Route as SoireesEvenementsTypeRouteImport } from './routes/soirees-evenements.$type'
import { Route as SoireesThematiquesIndexRouteImport } from './routes/soirees-thematiques.index'
import { Route as SoireesThematiquesSlugRouteImport } from './routes/soirees-thematiques.$slug'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const SplatRoute = SplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => rootRouteImport
          })
const AProposRoute = AProposRouteImport.update({
            id: '/a-propos',path: '/a-propos',getParentRoute: () => rootRouteImport
          })
const AvisClientsRoute = AvisClientsRouteImport.update({
            id: '/avis-clients',path: '/avis-clients',getParentRoute: () => rootRouteImport
          })
const CalculateurRoute = CalculateurRouteImport.update({
            id: '/calculateur',path: '/calculateur',getParentRoute: () => rootRouteImport
          })
const CielEtoileMariageRoute = CielEtoileMariageRouteImport.update({
            id: '/ciel-etoile-mariage',path: '/ciel-etoile-mariage',getParentRoute: () => rootRouteImport
          })
const ConditionsDeLocationRoute = ConditionsDeLocationRouteImport.update({
            id: '/conditions-de-location',path: '/conditions-de-location',getParentRoute: () => rootRouteImport
          })
const ContactezNousRoute = ContactezNousRouteImport.update({
            id: '/contactez-nous',path: '/contactez-nous',getParentRoute: () => rootRouteImport
          })
const DjAvignonRoute = DjAvignonRouteImport.update({
            id: '/dj-avignon',path: '/dj-avignon',getParentRoute: () => rootRouteImport
          })
const DjSaintSylvestreRoute = DjSaintSylvestreRouteImport.update({
            id: '/dj-saint-sylvestre',path: '/dj-saint-sylvestre',getParentRoute: () => rootRouteImport
          })
const DjVaucluseRoute = DjVaucluseRouteImport.update({
            id: '/dj-vaucluse',path: '/dj-vaucluse',getParentRoute: () => rootRouteImport
          })
const GalerieRoute = GalerieRouteImport.update({
            id: '/galerie',path: '/galerie',getParentRoute: () => rootRouteImport
          })
const GuideMariageVaucluseRoute = GuideMariageVaucluseRouteImport.update({
            id: '/guide-mariage-vaucluse',path: '/guide-mariage-vaucluse',getParentRoute: () => rootRouteImport
          })
const LeConceptRoute = LeConceptRouteImport.update({
            id: '/le-concept',path: '/le-concept',getParentRoute: () => rootRouteImport
          })
const LocationGenderRevealRoute = LocationGenderRevealRouteImport.update({
            id: '/location-gender-reveal',path: '/location-gender-reveal',getParentRoute: () => rootRouteImport
          })
const LocationKaraokeVaucluseRoute = LocationKaraokeVaucluseRouteImport.update({
            id: '/location-karaoke-vaucluse',path: '/location-karaoke-vaucluse',getParentRoute: () => rootRouteImport
          })
const LocationPhotoboothAvignonRoute = LocationPhotoboothAvignonRouteImport.update({
            id: '/location-photobooth-avignon',path: '/location-photobooth-avignon',getParentRoute: () => rootRouteImport
          })
const LocationSonoMariageRoute = LocationSonoMariageRouteImport.update({
            id: '/location-sono-mariage',path: '/location-sono-mariage',getParentRoute: () => rootRouteImport
          })
const MentionsLegalesRoute = MentionsLegalesRouteImport.update({
            id: '/mentions-legales',path: '/mentions-legales',getParentRoute: () => rootRouteImport
          })
const MerciRoute = MerciRouteImport.update({
            id: '/merci',path: '/merci',getParentRoute: () => rootRouteImport
          })
const PlanDuSiteRoute = PlanDuSiteRouteImport.update({
            id: '/plan-du-site',path: '/plan-du-site',getParentRoute: () => rootRouteImport
          })
const PolitiqueConfidentialiteRoute = PolitiqueConfidentialiteRouteImport.update({
            id: '/politique-confidentialite',path: '/politique-confidentialite',getParentRoute: () => rootRouteImport
          })
const RealisationsRoute = RealisationsRouteImport.update({
            id: '/realisations',path: '/realisations',getParentRoute: () => rootRouteImport
          })
const SoireeKaraokeAvignonRoute = SoireeKaraokeAvignonRouteImport.update({
            id: '/soiree-karaoke-avignon',path: '/soiree-karaoke-avignon',getParentRoute: () => rootRouteImport
          })
const SoireesThematiquesRoute = SoireesThematiquesRouteImport.update({
            id: '/soirees-thematiques',path: '/soirees-thematiques',getParentRoute: () => rootRouteImport
          })
const SonoLumiereRoute = SonoLumiereRouteImport.update({
            id: '/sono-lumiere',path: '/sono-lumiere',getParentRoute: () => rootRouteImport
          })
const TarifsRoute = TarifsRouteImport.update({
            id: '/tarifs',path: '/tarifs',getParentRoute: () => rootRouteImport
          })
const UnsubscribeRoute = UnsubscribeRouteImport.update({
            id: '/unsubscribe',path: '/unsubscribe',getParentRoute: () => rootRouteImport
          })
const ActualitesIndexRoute = ActualitesIndexRouteImport.update({
            id: '/actualites/',path: '/actualites/',getParentRoute: () => rootRouteImport
          })
const ActualitesSlugRoute = ActualitesSlugRouteImport.update({
            id: '/actualites/$slug',path: '/actualites/$slug',getParentRoute: () => rootRouteImport
          })
const DjAnniversaireVilleRoute = DjAnniversaireVilleRouteImport.update({
            id: '/dj-anniversaire/$ville',path: '/dj-anniversaire/$ville',getParentRoute: () => rootRouteImport
          })
const DjEntrepriseVilleRoute = DjEntrepriseVilleRouteImport.update({
            id: '/dj-entreprise/$ville',path: '/dj-entreprise/$ville',getParentRoute: () => rootRouteImport
          })
const DjMariageIndexRoute = DjMariageIndexRouteImport.update({
            id: '/dj-mariage/',path: '/dj-mariage/',getParentRoute: () => rootRouteImport
          })
const DjMariageVilleRoute = DjMariageVilleRouteImport.update({
            id: '/dj-mariage/$ville',path: '/dj-mariage/$ville',getParentRoute: () => rootRouteImport
          })
const DjMariagePackSonoLumiereRoute = DjMariagePackSonoLumiereRouteImport.update({
            id: '/dj-mariage/pack-sono-lumiere',path: '/dj-mariage/pack-sono-lumiere',getParentRoute: () => rootRouteImport
          })
const EnWeddingDjProvenceRoute = EnWeddingDjProvenceRouteImport.update({
            id: '/en/wedding-dj-provence',path: '/en/wedding-dj-provence',getParentRoute: () => rootRouteImport
          })
const LieuxIndexRoute = LieuxIndexRouteImport.update({
            id: '/lieux/',path: '/lieux/',getParentRoute: () => rootRouteImport
          })
const LieuxSlugRoute = LieuxSlugRouteImport.update({
            id: '/lieux/$slug',path: '/lieux/$slug',getParentRoute: () => rootRouteImport
          })
const LocationMaterielIndexRoute = LocationMaterielIndexRouteImport.update({
            id: '/location-materiel/',path: '/location-materiel/',getParentRoute: () => rootRouteImport
          })
const LocationMaterielSlugRoute = LocationMaterielSlugRouteImport.update({
            id: '/location-materiel/$slug',path: '/location-materiel/$slug',getParentRoute: () => rootRouteImport
          })
const SoireesEvenementsIndexRoute = SoireesEvenementsIndexRouteImport.update({
            id: '/soirees-evenements/',path: '/soirees-evenements/',getParentRoute: () => rootRouteImport
          })
const SoireesEvenementsTypeRoute = SoireesEvenementsTypeRouteImport.update({
            id: '/soirees-evenements/$type',path: '/soirees-evenements/$type',getParentRoute: () => rootRouteImport
          })
const SoireesThematiquesIndexRoute = SoireesThematiquesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => SoireesThematiquesRoute
          })
const SoireesThematiquesSlugRoute = SoireesThematiquesSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => SoireesThematiquesRoute
          })





const SoireesThematiquesRouteChildren = {
  SoireesThematiquesSlugRoute: SoireesThematiquesSlugRoute,SoireesThematiquesIndexRoute: SoireesThematiquesIndexRoute
}

const SoireesThematiquesRouteWithChildren = SoireesThematiquesRoute._addFileChildren(SoireesThematiquesRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,SplatRoute: SplatRoute,AProposRoute: AProposRoute,AvisClientsRoute: AvisClientsRoute,CalculateurRoute: CalculateurRoute,CielEtoileMariageRoute: CielEtoileMariageRoute,ConditionsDeLocationRoute: ConditionsDeLocationRoute,ContactezNousRoute: ContactezNousRoute,DjAvignonRoute: DjAvignonRoute,DjSaintSylvestreRoute: DjSaintSylvestreRoute,DjVaucluseRoute: DjVaucluseRoute,GalerieRoute: GalerieRoute,GuideMariageVaucluseRoute: GuideMariageVaucluseRoute,LeConceptRoute: LeConceptRoute,LocationGenderRevealRoute: LocationGenderRevealRoute,LocationKaraokeVaucluseRoute: LocationKaraokeVaucluseRoute,LocationPhotoboothAvignonRoute: LocationPhotoboothAvignonRoute,LocationSonoMariageRoute: LocationSonoMariageRoute,MentionsLegalesRoute: MentionsLegalesRoute,MerciRoute: MerciRoute,PlanDuSiteRoute: PlanDuSiteRoute,PolitiqueConfidentialiteRoute: PolitiqueConfidentialiteRoute,RealisationsRoute: RealisationsRoute,SoireeKaraokeAvignonRoute: SoireeKaraokeAvignonRoute,SoireesThematiquesRoute: SoireesThematiquesRouteWithChildren,SonoLumiereRoute: SonoLumiereRoute,TarifsRoute: TarifsRoute,UnsubscribeRoute: UnsubscribeRoute,ActualitesSlugRoute: ActualitesSlugRoute,DjAnniversaireVilleRoute: DjAnniversaireVilleRoute,DjEntrepriseVilleRoute: DjEntrepriseVilleRoute,DjMariageVilleRoute: DjMariageVilleRoute,DjMariagePackSonoLumiereRoute: DjMariagePackSonoLumiereRoute,EnWeddingDjProvenceRoute: EnWeddingDjProvenceRoute,LieuxSlugRoute: LieuxSlugRoute,LocationMaterielSlugRoute: LocationMaterielSlugRoute,SoireesEvenementsTypeRoute: SoireesEvenementsTypeRoute,ActualitesIndexRoute: ActualitesIndexRoute,DjMariageIndexRoute: DjMariageIndexRoute,LieuxIndexRoute: LieuxIndexRoute,LocationMaterielIndexRoute: LocationMaterielIndexRoute,SoireesEvenementsIndexRoute: SoireesEvenementsIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)